module.exports = __webpack_public_path__ + "static/img/12.a6efe75.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/2/1/eng/12.png
// module id = W3iR
// module chunks = 0